import type { GrantableUserPayload } from '@Application/SubjectTypeDefinitions/Actions/grantedUsersFetched';

class GrantableUserView {
	readonly id: number;
	readonly firstName: string;
	readonly lastName: string;

	constructor(payload: GrantableUserPayload) {
		this.id = payload.id;
		this.firstName = payload.firstName;
		this.lastName = payload.lastName;

		Object.freeze(this);
	}

	get displayName(): string {
		return `${this.firstName} ${this.lastName}`.trim();
	}
}

export default GrantableUserView;
